import { api, apiRequest } from "./api";
import type {
  GeneralAdvice,
  CreateGeneralAdviceRequest,
  UpdateGeneralAdviceRequest,
} from "@/types";

export type ParentType = "prescriptions" | "nutrition";

export const generalAdviceAPI = {
  get: (
    appointmentId: string,
    consolidated: boolean = false,
    parentType: ParentType = "prescriptions"
  ) =>
    apiRequest<GeneralAdvice | GeneralAdvice[]>(() =>
      api.get(`/${parentType}/general-advice/appointment/${appointmentId}/`, {
        params: { consolidated },
      })
    ),

  create: (
    appointmentId: string,
    data: CreateGeneralAdviceRequest,
    parentType: ParentType = "prescriptions"
  ) =>
    apiRequest<GeneralAdvice>(() =>
      api.post(
        `/${parentType}/general-advice/appointment/${appointmentId}/`,
        data
      )
    ),

  update: (
    generalAdviceId: string,
    data: UpdateGeneralAdviceRequest,
    parentType: ParentType = "prescriptions"
  ) =>
    apiRequest<GeneralAdvice>(() =>
      api.patch(`/${parentType}/general-advice/${generalAdviceId}/`, data)
    ),
};
